import React, { Component } from "react";
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { debounce,throttle } from '../../utils/util';

class RecommendationsCartItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quantity: this.props.product.quantity ? this.props.product.quantity : 1
    };
    
    this.goodsQuantityChage =this.goodsQuantityChage.bind(this)

  }

  componentDidMount() {
  
  }

  componentDidUpdate(prevProps) {
    
  }

  fun_mangerGoodsSumAddorReduce = (type) =>{
    if(!this.props.available){
      return false
    }
    
   if( type == 'add'){
    if(this.props.product.inventory > this.state.quantity ){
      this.setState({quantity: (this.state.quantity)*1 + 1},()=>{
        var productObj = this.props.product;
        productObj.quantity = this.state.quantity;
        this.props.fun_changeGoodsQuantity(productObj,'cartGoodsQuantityChange');
      })
    }else{
      alert("Insufficient stock");
    }
   }else if(type == 'reduce'){
     if((this.state.quantity)*1  > 1  ){
      this.setState({quantity: (this.state.quantity)*1 - 1},()=>{
        var productObj = this.props.product;
        productObj.quantity = this.state.quantity;
        this.props.fun_changeGoodsQuantity(productObj,'cartGoodsQuantityChange')
      })
     }
   }
  }

  goodsQuantityChage(e){
    let vlaue =  e.target.value;
    if(vlaue > 0){
      this.setState({
        quantity:vlaue
      },()=>{
        var productObj = this.props.product;
        productObj.quantity = vlaue;
  
        if(this.props.product.inventory > this.state.quantity ){
          this.props.fun_changeGoodsQuantity(productObj,'cartGoodsQuantityChange');
        }else{
          this.setState({quantity: this.props.product.inventory});
        }
      })
    }
  }

  render() {
    if (this.props.product) {
      var product = this.props.product;

      var price = this.props.price;
      var available =  this.props.available;
      var index = this.props.index;
      var productName = this.props.productName;
      var inventory = this.props.product.inventory;
      let discountCodeData = this.props.discountCodeData;
      let entitled_product_ids = [] ;
      try {
        entitled_product_ids = discountCodeData.price_rule.entitled_product_ids;
      } catch (error) {
        entitled_product_ids = [];
      }  


      return (
        <div className="products-cart-item-row">
            <div className={available ? "products-cart-item": "products-cart-item no-available" } key={`products-cart-item--${index}`}>
                <div className="products-cart-item-image">
                    <img alt={ productName } src={ product.coverImageSource } />
                </div>
                <div className="products-cart-item-name-price">
                    <div className="product-cart-item-name">
                        <div className="product-cart-item-goods-brand">{product.vendor}</div>
                        <div className="product-cart-item-goods-name">{ productName }</div>
                        {
                          Number(inventory) < this.state.quantity ?<div className="product-cart-quantity" style={{color: '#d0021b'}}>Insufficient stock</div> : Number(inventory) <= 0 ? <div className="product-cart-quantity" style={{color: '#d0021b'}}>Out of stock</div>
                          :  available ? <div></div> : <div className="product-cart-quantity" style={{color: '#d0021b'}}>Out of stock</div>
                        }
                      
                    </div>
                    <div className="product-cart-item-price-delete">
                        <div className="product-cart-item-quantity">
                            <div className="product-cart-item-quantity-reduce-add-button" onClick={(e)=>{   throttle(this.fun_mangerGoodsSumAddorReduce('reduce' ))   }}>-</div>
                            <input type="text" readOnly={this.props.available ? false : true} name="goodsQuantity" value={this.state.quantity } onChange={ (e)=>{ debounce(this.goodsQuantityChage(e),1000) }}></input>
                            <div className="product-cart-item-quantity-reduce-add-button" onClick={()=>{ throttle(this.fun_mangerGoodsSumAddorReduce('add'))  }}>+</div>
                        </div>
                        {
                          this.props.isEntitlePrice > 0 && entitled_product_ids.includes(product.id) ?
                          <div className="product-cart-item-price" style={{textDecoration:'line-through',marginTop:'4px'}}>
                            { price }
                          </div>:
                          <div className="product-cart-item-price" style={ available ? { fontStyle: 'inherit'} : {textDecoration:'line-through'}}>
                              { price }
                          </div>
                        }
                        {
                          this.props.isEntitlePrice > 0 && entitled_product_ids.includes(product.id)  ?
                          <div className="product-cart-item-price" style={ available ? { fontStyle: 'inherit'} : {textDecoration:'line-through'}}>
                            ${ (product.price * ( ( 100 -  parseFloat(this.props.amountAvailableForDiscount) ) / 100)) .toFixed(2) }
                          </div>: null
                        }
                    </div>
                </div>
            </div>
            <div onClick={ () => {
                this.props.handleDeleteProduct(product);
                this.props.fun_handleDeleteProduct_emptyData();
                this.props.recalculate();
                }} className="product-cart-item-delete">
            </div>
        </div>
      );
    } else {
      return <div className="products-cart-item-row" style={{ visibility: "hidden" }} />;
    }
  }
}

export default RecommendationsCartItem;



// WEBPACK FOOTER //
// ./src/views/recommendations/RecommendationCartItem.js